<template>
  <div id="">
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          <el-input v-model="filters.name" placeholder="搜索关键字"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="el-form-button" type="primary" v-on:click="loadData">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button class="el-form-button" type="success" @click="addInfo">新增</el-button>
        </el-form-item>
      </el-form>
    </el-col>

    <el-table
      :data="tableData"
      style="width: 100%"
      row-key="id"
      border
      lazy
      :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
      <el-table-column prop="id" label="ID" width="50"></el-table-column>
      <el-table-column prop="name" label="角色名称" show-overflow-tooltip width="150"></el-table-column>
      <el-table-column prop="remark" label="角色说明" width="150"></el-table-column>
      <el-table-column prop="createDate" label="创建时间" width="150"></el-table-column>
      <el-table-column prop="updateDate" label="更新时间" width="150"></el-table-column>
      <!--第二步  开始进行修改和查询操作-->
      <el-table-column label="操作" align="center" min-width="200">
        <template slot-scope="scope">
          <el-button type="primary" @click="modifyMenu(scope.row)">权限</el-button>
          <el-button type="warning" @click="modifyInfo(scope.row)">修改</el-button>
          <el-button type="danger" @click="deleteInfo(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--分页组件-->
    <PageGroup v-bind:pageInfo="pageInfo" @pageChange="loadData"></PageGroup>

    <!--信息界面-->
    <el-dialog title="信息" :visible.sync="showInfo" width="50%" :close-on-click-modal="false">
      <el-form :model="addFormData" :rules="rules2" ref="addFormData" label-width="150px" class="demo-ruleForm">
        <el-row>
          <el-col :span="24">
            <el-form-item prop="name" label="角色名称：">
              <el-input type="text" v-model.trim="addFormData.name" placeholder="角色名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item prop="remark" label="角色说明：">
              <el-input type="text" v-model="addFormData.remark" placeholder="角色说明"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button @click.native="showInfo = false">取 消</el-button>
          <el-button type="primary" @click.native="sendSaveInfo">确 定</el-button>
      </span>
    </el-dialog>

    <!--权限界面-->
    <el-dialog title="权限" :visible.sync="showMenu" width="50%" :close-on-click-modal="false">
      <el-form :model="addFormData" :rules="rules2" ref="addFormData" label-width="150px" class="demo-ruleForm">
        <el-row>
          <el-col :span="24">
            <el-form-item prop="remark" label="选择菜单：">
              <el-tree
                :data="tree"
                show-checkbox
                node-key="id"
                ref="tree"
                :default-checked-keys="checkKeys"
                :props="defaultProps"
                style="padding-top:10px"
              >
              </el-tree>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button @click.native="showMenu = false">取 消</el-button>
          <el-button type="primary" @click.native="sendSaveMenu">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import {sysApi} from '../../api/index';
import {HttpResp} from "../../constant";
import PageGroup from "../template/PageGroup";

export default {
  components: {PageGroup},
    data() {
      return {
        tableData: [],
        addFormReadOnly: true,
        showInfo: false,
        showMenu: false,
        addFormData: {
          id: '',
          name: '',
          remark: ''
        },
        rules2: {
          name: [{ required: true, message: '角色名称不能为空', trigger: 'blur'}],
        },

        filters: {
            name: ''
        },

        pageInfo: {
          pageNumber: 1, //默认在第一页
          pageSize: 10, //默认每页显示1条数据
          total: 1, //默认总条数为一条
        },

        //树形菜单属性。
        tree: [],
        checkKeys:[],
        defaultProps: {
          children: 'children',
          label: 'label'
        }
      }
    },
    mounted: function () {
      this.loadData();
    },
    computed: {

    },
    methods: {
      // 查询菜单树，用于创建修改角色
      loadMenu() {
        sysApi.listMenu().then(data => {
          if(data.code === HttpResp.SUCCUSS){
            this.tree = data.data;
          } else {
            this.$message({
              type: 'info',
              message: `查询数据失败`
            });
          }
        });
      },
      loadData() {
        let param = {
          pageNumber: this.pageInfo.pageNumber,
          pageSize: this.pageInfo.pageSize,
          name: this.filters.name
        };
        sysApi.listRole(param).then(data => {
            //console.info(result);
            if(data.code === HttpResp.SUCCUSS){
              this.tableData = data.data.dataList;
              this.pageInfo.count = data.data.total;
            }else{
              this.$message({
                type: 'error',
                message: data.message
              });
            }
        });
      },
      // 增加角色
      addInfo() {
          this.addFormData = {
            id: null,
            name: '',
            remark: ''
          };
          this.showInfo = true;
      },
      // 修改菜单
      modifyMenu(rowData) {
          this.addFormData = {
            id: rowData.id,
            name: rowData.name,
            remark: rowData.remark
          };
          this.showMenu = true;
          //加载菜单树
          this.tree = this.getMenus(rowData.id);
      },
      modifyInfo(rowData) {
          this.addFormData = {
            id: rowData.id,
            name: rowData.name,
            remark: rowData.remark
          }
          this.showInfo = true;
      },
      deleteInfo(rowData) {
        this.$confirm('是否删除这条记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          sysApi.deleteRole(rowData.id).then(data => {
            if(data.code === HttpResp.SUCCUSS){
                this.$message({
                  type: 'success',
                  message: "删除成功"
                });
              this.loadData();
            }else{
              this.$message({
                type: 'error',
                message: data.message
              });
            }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });

      },
      // 保存信息
      sendSaveInfo() {
          //先判断表单是否通过了判断
          this.$refs.addFormData.validate((valid) => {
              //代表通过验证 ,将参数传回后台
              if (valid) {
                  // 角色信息
                  let data = {
                    id: this.addFormData.id,
                    name: this.addFormData.name,
                    remark: this.addFormData.remark
                  };
                  sysApi.saveRole(data).then(data => {
                      if (data.code === HttpResp.SUCCUSS) {
                          this.$message({
                              type: 'success',
                              message: '保存成功',
                          });
                          this.loadData();
                      } else {
                          this.$message({
                              type: 'error',
                              message: data.message,
                          });
                      }
                      this.showInfo = false;
                  });
              }
          });
      },
      // 保存角色菜单关联
      sendSaveMenu() {
        let menuIds = this.$refs.tree.getCheckedKeys()
        //选中的菜单
        let data = {
          roleId : this.addFormData.id,
          menuIds : menuIds,
        };
        sysApi.saveRoleMenu(data).then(data => {
          if (data.code === HttpResp.SUCCUSS) {
            this.$message({
              type: 'success',
              message: '保存成功',
            });
            this.loadData();
          } else {
            this.$message({
              type: 'error',
              message: data.message,
            });
          }
          this.showMenu = false;
        });
      },
      getMenus(roleId) {
        this.loadMenu();
        sysApi.listMenuIdByRoleId(roleId).then(data => {
          if(data.code === HttpResp.SUCCUSS){
            //已选项
            this.checkKeys = data.data;
          }else{
            this.$message({
              type: 'info',
              message: `查询数据失败`
            });
          }
        });
      },

    }

}
</script>



// WEBPACK FOOTER //
// src/components/sys/SysRole.vue